import React, {useState} from "react";
import {LoadingButton} from "@mui/lab";
import {ConfirmDialog} from "../../components/Common/Confirm";
import {
    Alert,
    Button, Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Divider,
    TextField
} from "@mui/material";
import {
    useCreateChargeTemplateMutation,
    useDeleteChargeTemplateMutation,
    useGetAllChargeTemplatesQuery
} from "../../core/api/charge-template-api";
import Loading from "../../components/Common/Loading";

export const ChargeTemplate = ({isChargeButtonDisable, game, selectedItemList, setSelectedItemList}) => {



    const {
        data: chargeTemplates,
        isLoadingCT,
        isSuccessCT,
        isErrorCT,
        errorCT
    } = useGetAllChargeTemplatesQuery(game)

    const [
        createChargeTemplate,
        createChargeTemplateResponse
    ] = useCreateChargeTemplateMutation()

    const [
        deleteChargeTemplate,
        deleteChargeTemplateResponse
    ] = useDeleteChargeTemplateMutation()

    const [childChanged, setIsChildChanged] = useState(false);
    const [someChildIsBlocking, setSomeChildIsBlocking] = useState([])
    const [confirmDeleteTemplate, setConfirmDeleteTemplate] = useState(false)
    const [selectedTemplate, setSelectedTemplate] = useState(false)
    const [templateName, setTemplateName] = useState("")
    const [templatePopup, setShowTemplatePopup] = useState(false)
    const createTemplateHandler = async () => {
        
        await createChargeTemplate({
            data: JSON.stringify(selectedItemList),
            game: game,
            title: templateName
        })
        handleCloseTemplateDialog()
    }

    const handleDeleteTemplate = (template) => {
        deleteChargeTemplate({title:template.title, game:template.game, data:"-"})
    }

    const selectTemplate = (template) => {
        //setSelectedItemList([])
        const data = JSON.parse(template.data)
        setSelectedItemList(data)

        setSomeChildIsBlocking(new Array(data.length).fill(false))
    }

    const handleCloseTemplateDialog = () => {
        setShowTemplatePopup(false)
        setTemplateName("")
    }

    return <>

        <Divider sx={{mt:3, mb:3}} />

        <Loading isLoading={isLoadingCT} isError={isErrorCT} error={errorCT}>
            {chargeTemplates!=undefined&&<>
                <b>Templates: </b> {chargeTemplates.map(item => <Chip sx={{mr:1, mb:1}} onClick={()=>{selectTemplate(item)}} label={item.title} variant="outlined" onDelete={() => {
                setSelectedTemplate(item)
                setConfirmDeleteTemplate(true)
            }} />)}
            </>}
        </Loading>

        <LoadingButton
            sx={{mr: 1, ml: 0, mt:1}}
            disabled={isChargeButtonDisable}
            loading={createChargeTemplateResponse.isLoading}
            variant={"outlined"}
            color={"success"}
            onClick={() => setShowTemplatePopup(true)}>Create template</LoadingButton>
        {confirmDeleteTemplate&&<ConfirmDialog
            open={confirmDeleteTemplate}
            handleClose={() => {setConfirmDeleteTemplate(false)}}
            handleConfirm={() => {
                handleDeleteTemplate(selectedTemplate)
                setConfirmDeleteTemplate(false)

            }}
        />}

        {templatePopup&&<Dialog open={templatePopup} onClose={handleCloseTemplateDialog}>
            <DialogTitle>Set ChargeTemplate Name</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <TextField value={templateName} onChange={(e) => setTemplateName(e.target.value)} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseTemplateDialog} variant={"outlined"} color="error">
                    Cancel
                </Button>
                <Button onClick={() => createTemplateHandler()} disabled={templateName.length == 0} variant={"contained"} color="primary" autoFocus>
                    Create
                </Button>
            </DialogActions>
        </Dialog>}
    </>
}
